import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from 'api/axiosBaseQuery';

const apaleoApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL ?? '',
  }),
  reducerPath: 'apaleoApi',
  tagTypes: [
    'Properties',
    'Token',
    'IntegrationRequest',
    'RatePlan',
  ],
  endpoints: () => ({}),
});

export default apaleoApi;
